export const seoConfig = {
  '/': {
    title: 'Syncreos: The #1 Platform for Creators | Collaborate, Create & Earn',
    description: 'A dedicated platform where creative individuals can meet, collaborate on projects, and showcase their work.',
    canonical: 'https://www.syncreos.com',
    ogUrl: 'https://www.syncreos.com',
    ogTitle: 'Syncreos: The #1 Platform for Creators | Collaborate, Create & Earn',
    ogDescription: 'A dedicated platform where creative individuals can meet, collaborate on projects, and showcase their work.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos platform homepage screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Syncreos: The #1 Platform for Creators | Collaborate, Create & Earn',
    twitterDescription: 'A dedicated platform where creative individuals can meet, collaborate on projects, and showcase their work.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos platform homepage screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/explore': {
    title: 'Explore Music Projects - Syncreos',
    description: 'Discover amazing music projects created by talented artists on Syncreos. Explore, collaborate, and get inspired.',
    canonical: 'https://www.syncreos.com/explore',
    ogUrl: 'https://www.syncreos.com/explore',
    ogTitle: 'Explore Music Projects - Syncreos',
    ogDescription: 'Discover amazing music projects created by talented artists on Syncreos.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc2.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos explore page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Explore Music Projects - Syncreos',
    twitterDescription: 'Discover amazing music projects created by talented artists on Syncreos.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc2.png',
    twitterImageAlt: 'Syncreos explore page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/projects': {
    title: 'Music Projects - Syncreos',
    description: 'Browse and join music collaboration projects. Find your next creative endeavor on Syncreos.',
    canonical: 'https://www.syncreos.com/projects',
    ogUrl: 'https://www.syncreos.com/projects',
    ogTitle: 'Music Projects - Syncreos',
    ogDescription: 'Browse and join music collaboration projects.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc3.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos projects page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Music Projects - Syncreos',
    twitterDescription: 'Browse and join music collaboration projects.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc3.png',
    twitterImageAlt: 'Syncreos projects page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/friends': {
    title: 'Friends & Connections - Syncreos',
    description: 'Connect with fellow musicians and collaborate on projects. Build your music network on Syncreos.',
    canonical: 'https://www.syncreos.com/friends',
    ogUrl: 'https://www.syncreos.com/friends',
    ogTitle: 'Friends & Connections - Syncreos',
    ogDescription: 'Connect with fellow musicians and collaborate on projects.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc4.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos friends page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Friends & Connections - Syncreos',
    twitterDescription: 'Connect with fellow musicians and collaborate on projects.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc4.png',
    twitterImageAlt: 'Syncreos friends page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/library': {
    title: 'My Music Library - Syncreos',
    description: 'Access your personal music library, saved projects, and contributions on Syncreos.',
    canonical: 'https://www.syncreos.com/library',
    ogUrl: 'https://www.syncreos.com/library',
    ogTitle: 'My Music Library - Syncreos',
    ogDescription: 'Access your personal music library and contributions.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc5.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos library page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'My Music Library - Syncreos',
    twitterDescription: 'Access your personal music library and contributions.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc5.png',
    twitterImageAlt: 'Syncreos library page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/remix': {
    title: 'Remix & Collaborate - Syncreos',
    description: 'Discover creative projects and find opportunities to remix and collaborate on Syncreos.',
    canonical: 'https://www.syncreos.com/remix',
    ogUrl: 'https://www.syncreos.com/remix',
    ogTitle: 'Remix & Collaborate - Syncreos',
    ogDescription: 'Discover creative projects and remix with other artists.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc6.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos remix page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, remix, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Remix & Collaborate - Syncreos',
    twitterDescription: 'Discover creative projects and remix with other artists.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc6.png',
    twitterImageAlt: 'Syncreos remix page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/terms-of-service': {
    title: 'Terms of Service - Syncreos',
    description: 'Read the terms of service for using Syncreos, the collaborative music creation platform.',
    canonical: 'https://www.syncreos.com/terms-of-service',
    ogUrl: 'https://www.syncreos.com/terms-of-service',
    ogTitle: 'Terms of Service - Syncreos',
    ogDescription: 'Terms of service for Syncreos.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos terms of service page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Terms of Service - Syncreos',
    twitterDescription: 'Terms of service for Syncreos.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos terms of service page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/privacy-policy': {
    title: 'Privacy Policy - Syncreos',
    description: 'Learn about how Syncreos protects your privacy and handles your data.',
    canonical: 'https://www.syncreos.com/privacy-policy',
    ogUrl: 'https://www.syncreos.com/privacy-policy',
    ogTitle: 'Privacy Policy - Syncreos',
    ogDescription: 'Privacy policy for Syncreos.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos privacy policy page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Privacy Policy - Syncreos',
    twitterDescription: 'Privacy policy for Syncreos.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos privacy policy page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/notifications': {
    title: 'Notifications - Syncreos',
    description: 'Stay updated with your latest notifications on Syncreos.',
    canonical: 'https://www.syncreos.com/notifications',
    ogUrl: 'https://www.syncreos.com/notifications',
    ogTitle: 'Notifications - Syncreos',
    ogDescription: 'Stay updated with your latest notifications on Syncreos.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc7.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos notifications page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Notifications - Syncreos',
    twitterDescription: 'Stay updated with your latest notifications on Syncreos.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos notifications page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/share': {
    title: 'Share - Syncreos',
    description: 'Share your creative projects and content with the Syncreos community.',
    canonical: 'https://www.syncreos.com/share',
    ogUrl: 'https://www.syncreos.com/share',
    ogTitle: 'Share - Syncreos',
    ogDescription: 'Share your creative projects and content with the Syncreos community.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos share page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Share - Syncreos',
    twitterDescription: 'Share your creative projects and content with the Syncreos community.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos share page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/login': {
    title: 'Login - Syncreos',
    description: 'Log in to your Syncreos account to access collaborative creative projects.',
    canonical: 'https://www.syncreos.com/login',
    ogUrl: 'https://www.syncreos.com/login',
    ogTitle: 'Login - Syncreos',
    ogDescription: 'Log in to your Syncreos account to access collaborative creative projects.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos login page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Login - Syncreos',
    twitterDescription: 'Log in to your Syncreos account to access collaborative creative projects.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos login page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
  '/register': {
    title: 'Register - Syncreos',
    description: 'Create a new account on Syncreos to start collaborating on creative projects.',
    canonical: 'https://www.syncreos.com/register',
    ogUrl: 'https://www.syncreos.com/register',
    ogTitle: 'Register - Syncreos',
    ogDescription: 'Create a new account on Syncreos to start collaborating on creative projects.',
    ogImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    ogImageWidth: 1200,
    ogImageHeight: 630,
    ogImageAlt: 'Syncreos register page screenshot',
    ogType: 'website',
    googlebot: 'index, follow',
    robots: 'index, follow',
    keywords: 'Syncreos, creative collaboration, project management, portfolio, artists, musicians, writers, designers, creative community',
    author: 'Syncreos Team',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Register - Syncreos',
    twitterDescription: 'Create a new account on Syncreos to start collaborating on creative projects.',
    twitterImage: 'https://www.syncreos.com/screenshots/desktop/pc1.png',
    twitterImageAlt: 'Syncreos register page screenshot',
    twitterImageWidth: 1920,
    twitterImageHeight: 1080,
  },
};